import React from 'react'
import Menu, { MenuProps } from 'components/menu'
import Flag from 'components/flag'
import { Audit, Backup } from 'components/icons'

interface HistoryMenuProps extends MenuProps {
  setBackupModal: (open: boolean) => void
  setAuditModal: (open: boolean) => void
}

const HistoryMenu: React.FC<HistoryMenuProps> = ({
  id,
  menuState,
  setMenuState,
  width,
  setBackupModal,
  setAuditModal
}) => {
  return (
    <Menu id={id} menuState={menuState} setMenuState={setMenuState} width={width} zIndex={3000}>
      <li
        className="relative flex items-center rounded text-body select-none transition-all truncate cursor-pointer hover:bg-surface-sunken m-2.5 h-8 leading-[32px] py-0 px-2.5"
        onClick={() => setAuditModal(true)}
      >
        <div
          className="relative flex items-center rounded text-body select-none transition-all truncate cursor-pointer hover:bg-surface-sunken h-8 leading-[32px] py-0 px-2.5"
          title="View audit trail."
        >
          <Audit />
          <span className="ml-2.5">Audit Trail</span>
        </div>
      </li>

      <li
        className="relative flex items-center rounded text-body select-none transition-all truncate cursor-pointer hover:bg-surface-sunken m-2.5 h-8 leading-[32px] py-0 px-2.5"
        onClick={() => setBackupModal(true)}
      >
        <div className="relative flex items-center rounded text-body select-none transition-all truncate cursor-pointer hover:bg-surface-sunken h-8 leading-[32px] py-0 px-2.5">
          <Backup />
          <span className="flex items-center ml-2.5">
            Table Backups
            <Flag text="Beta" color="var(--color-red)" />
          </span>
        </div>
      </li>
    </Menu>
  )
}

export default HistoryMenu
